import { LegalDocument } from '../../components/legal/LegalDocument';
import { privacyAppContent } from '../../content/legal/privacyAppContent';

export function AppPrivacy() {
  return (
    <LegalDocument
      content={privacyAppContent}
      platform="app"
      seoDescription="LuvLust Privacy Policy. Learn how we collect, use, and protect your information on iOS and Android."
      seoKeywords="luvlust privacy policy, data protection, couples app privacy"
    />
  );
}
